export const FirebaseConfig = {
	"projectId": "allodriver-9139a",
	"appId": "1:456416299747:web:2210401594f1af842a93d6",
	"databaseURL": "https://allodriver-9139a-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "allodriver-9139a.firebasestorage.app",
	"apiKey": "AIzaSyBarZsEZzVGvNOs_bgMy0GC3XWdAufwDWc",
	"authDomain": "allodriver-9139a.firebaseapp.com",
	"messagingSenderId": "456416299747",
	"measurementId": "G-89NSSSL83D",
	"projectNumber": "456416299747",
	"version": "2"
};